import styled, { css } from 'styled-components';
import Image from 'global/Image';

interface ImageContainerProps {
  width?: number;
  height?: number;
}

export const ImageContainer = styled(Image)<ImageContainerProps>`
  width: ${({ width = 40 }) => width}px;
  height: ${({ height = 40 }) => height}px;

  border-radius: 100%;
`;

interface GroupAvatarProps {
  width?: number;
  height?: number;
}

export const GroupAvatar = styled.div<GroupAvatarProps>`
  width: ${({ width = 40 }) => width}px;
  height: ${({ height = 40 }) => height}px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 100%;
  overflow: hidden;
  background: #ebf8f3;
  color: #00ab6b;
`;
